import vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios';
Vue.use(vuex)

const carga = {
    namespaced: true,
    state: {
        error: false,       
    },
    actions: {              
        async   post_cargararchivote({ commit }, payload) {
            commit('SET_ERROR', false);
            let tran = payload.idtransaccion;
            let fallo = false;
            for (let i = 0; i < payload.archivo.length; i++) {                
                let temp = payload.archivo[i];
                if (temp.idsoporte <= 0 && !fallo) {
                    // let posicion = temp.archivocompleto.indexOf(";base64,", 0)
                    let paquetes = payload.tamanopaquete;
                    //let valor = payload.archivo.substring(posicion+ 8);
                    let valor = temp.archivocompleto;
                    let iteracion = valor.substring(0, paquetes);
                    valor = valor.substring(paquetes);
                    let error = 0;                    
                    let parte = 1;
                    while (iteracion.length > 0) {
                        console.log('intento ' + error + 'parte ' +  parte)                        
                        await axios.post(`${process.env.VUE_APP_REST}/api/soporte/temporal`,
                            {
                                "transaccion": tran,
                                "parte": parte,
                                "archivo": temp.nombrearchivo
                                , "archivocompleto": iteracion
                                , "idavance": temp.idavance
                                , "tipo": temp.tipoarchivo
                                , "publico": temp.publico
                            })
                            .then(function () {                                
                                iteracion = valor.substring(0, paquetes);
                                valor = valor.substring(paquetes);
                                error = 0;
                                parte = parte + 1;
                            })
                            .catch(() => {                                
                                error = error + 1;
                                if (error > 2) {
                                    fallo = true;
                                    iteracion = "";

                                }
                            })
                    }
                    if (fallo)
                    {
                        commit('SET_ERROR', true);
                    }                    
                }
            }
        }       
    },
    mutations: {
        SET_ERROR(state, mensaje) {
            state.error = mensaje
        }    
    },
    getters: {
        gerrorcarga(state) {
            return state.error
        }
    }
}

export default carga;
